import React from "react";
import Channels from "./Channels";
import Container from "./Container";

const Home = () => {
  return (
    <Container>
      <p>
        Ciao e benvenuto nel <b>Prismanetwork</b>!
      </p>
      <p>
        Qui raccogliamo tutti i link e le cose che vengono fuori dal mondo
        Prism*
      </p>
      <p>
        Qui sotto ci sono i link ai canali principali, nella sezione{" "}
        <b>Statistiche</b> alcuni dati emersi dal grande e insindacabile
        schedario della Prismachat, infine nella sezione <b>Spinoff</b> troverai
        tutti i link ai sottogruppi generati dalla Prismachat madre!
      </p>

      <Channels />
    </Container>
  );
};

export default Home;
